import { Injectable } from '@angular/core';
import {
  ID,
  QueryEntity
} from '@datorama/akita';
import {
  ChartsDashboardSeriesState,
  ChartsDashboardSeriesStore
} from './charts-dashboard-series.store';
import { ICard } from '../card';
import { Observable } from 'rxjs';
import { IChartSeries } from './chart-series.model';
import { map } from 'rxjs/operators';
import { CardTypeEnum } from '../../interfaces';

@Injectable({ providedIn: 'root' })
export class ChartsDashboardSeriesQuery extends QueryEntity<ChartsDashboardSeriesState> {

  constructor(protected store: ChartsDashboardSeriesStore) {
    super(store);
  }

  public selectSeriesFromCard(card: ICard<ID>): Observable<IChartSeries[]> {
    return this.selectAll()
      .pipe(map((series: IChartSeries[]) => {
        return series.filter((_series: IChartSeries) => card.chartSeries.find((id: ID) => id === _series.id));
      }));
  }

  public getSeriesFromCard(card: ICard<ID>): IChartSeries[] {
    if (card.type !== CardTypeEnum.FILLED) return [];

    return card.chartSeries.map((id: ID) => this.getEntity(id));
  }

}
